/** Grid sentinel id for the “Customize a product” tile (not an off-the-shelf catalog row). */
export const CUSTOMIZE_STATIONERY_GRID_ID = 'customize' as const

/** Grid sentinel id for the user’s saved handwriting stationery (current design project). */
export const MY_HANDWRITING_STATIONERY_GRID_ID = 'my-handwriting' as const
